<template>
    <el-dialog
            title="报废"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item label="报废日期" prop="bfrq">
                <el-date-picker
                        :picker-options="pickerOptions"
                        v-model="dataForm.bfrq"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="营业外收入" prop="yywsr">
                <el-input clearable v-model="dataForm.yywsr" ></el-input>
            </el-form-item>
            <el-form-item label="清理费用" prop="qlfy">
                <el-input clearable v-model="dataForm.qlfy" ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            const validateNumber = (rule, value, callback) => {
                if (value) {
                    var patrn = /^\d+(\.\d+)?$/;
                    if (!patrn.exec(value)) {
                        callback(new Error('请填写数字'))
                    } else {
                        callback()
                    }
                } else callback()
            }
            return {
                //表单验证规则
                rules: {
                    qlfy: [{validator:validateNumber,trigger: 'blur'}],
                    bfrq: [{ required: true, message: '报废日期不能为空', trigger: 'blur' }],
                    yywsr: [{validator:validateNumber,trigger: 'blur'}]
                },
                visible: false,
                dataForm: {
                id: '',
                qlfy: '',
                bfrq: '',
                yywsr: ''
                },
                beginUseTime:'',
                allUseTimeMonth:'',
                allUseTimeYear:'',
                bfrq:'',
                pickerOptions : {
                    shortcuts: [
                        {
                    text: '预计报废日期',
                    onClick:(picker)=> {
                        console.log(this.bfrq)
                        picker.$emit('pick', this.$moment(this.bfrq).format('YYYY-MM-DD'));
                    }},
                        {
                    text: '今天',
                    onClick:(picker)=> {
                        let time = new Date()
                        if ((this.bfrq&&(time.getTime() >= this.bfrq.getTime())))
                        picker.$emit('pick', time);
                    }
                }],disabledDate:(time) => {
                        return (this.bfrq&&(time.getTime() < this.bfrq.getTime()))
                    }

                }

            }
        },
        methods: {
            init (row,type) {
                this.dataForm.id = row.id
                this.beginUseTime = row.beginUseTime
                this.allUseTimeMonth = row.allUseTimeMonth
                this.allUseTimeYear = row.allUseTimeYear
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.beginUseTime) {
                    //    this.bfrq = this.$moment(this.beginUseTime).add(this.allUseTimeYear?this.allUseTimeYear:0,'y').add(this.allUseTimeMonth?this.allUseTimeMonth:0,'m').toDate()
                    this.bfrq = this.$moment(this.beginUseTime).toDate()
                    if(this.allUseTimeYear) {
                        this.bfrq = this.$moment(this.$moment(this.bfrq).format("YYYY-MM-DD HH:mm:ss")).add(this.allUseTimeYear,'years').toDate()
                    }
                    if(this.allUseTimeMonth) {
                        this.bfrq = this.$moment(this.$moment(this.bfrq).format("YYYY-MM-DD HH:mm:ss")).add(this.allUseTimeMonth,'months').toDate()
                    }
                    if (type === 1) {
                        this.dataForm.qlfy = row.qlfy
                        this.dataForm.bfrq = row.bfrq
                        this.dataForm.yywsr = row.yywsr
                    } else this.dataForm.bfrq = this.$moment(this.bfrq).format('YYYY-MM-DD')
                }
                })

            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {
              this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.$http({
                        url: '/bjba/asset/setBf',
                        method: 'post',
                        data: this.dataForm
                    }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                         })
                        this.visible = false
                        this.$emit('refreshDataList')
                    } else if(data && data.code === 500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                    })
                    }
                })
            }
        }
    }
</script>
